// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("./../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-goods-js": () => import("./../src/pages/goods.js" /* webpackChunkName: "component---src-pages-goods-js" */),
  "component---src-pages-index-js": () => import("./../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-raffle-js": () => import("./../src/pages/raffle.js" /* webpackChunkName: "component---src-pages-raffle-js" */)
}

